export const SET_INITIALIZED = (state, payload) => { state.initialized = payload }
export const SET_LOADING = (state, payload) => { state.loading = payload }
export const SET_TOWNSHIPS = (state, payload) => { state.townships = payload }
export const SET_EXPIRATION_DATE = (state) => {
  const date = new Date()
  date.setDate(date.getDate() + 1)
  state.expirationDate = date
}
